/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ProcedureCategory {
  SCT_24642003 = 'Psychiatry Procedure Or Service',

  SCT_409063005 = 'Counselling',

  SCT_409073007 = 'Education',

  SCT_387713003 = 'Surgical Procedure',

  SCT_103693007 = 'Diagnostic Procedure',

  SCT_46947000 = 'Chiropractic Manipulation',

  SCT_410606002 = 'Social Service Procedure',
}
